import React from 'react';

import type { MemberItemProps } from './types';

import './MemberItem.css';

export const MemberItem = React.memo(function MemberItem({
  member,
  isCurrentUser,
  isPending,
  canEdit,
  renderName,
  renderAvatar,
  renderRole,
  onConfirm,
  onLeave,
  onRemove,
  onRemoveReservation,
  isExtra,
}: MemberItemProps) {
  const badgeClass = member.status === 'confirmed' ? 'mi-avatar-wrap--confirmed' : 'mi-avatar-wrap--pending';
  const roleBadge = renderRole ? renderRole(member.telegramId) : null;

  const avatar = (
    <div className={`mi-avatar-wrap ${badgeClass}`}>
      <div className="mi-avatar">
        {renderAvatar ? renderAvatar(member.telegramId) : <span className="member-avatar-placeholder">{'?'}</span>}
      </div>
    </div>
  );

  if (isExtra) {
    return (
      <div className="member-item member-item--reserved-extra">
        {avatar}
        {roleBadge}
        <div className="mi-content">
          <div className="member-info">
            <span className="member-name">{renderName(member.telegramId)}</span>
            <span className="member-reserved-label">Зарезервировано</span>
          </div>
          {canEdit && onRemoveReservation && (
            <button
              type="button"
              className="member-remove-btn"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveReservation(Number(member.telegramId));
              }}
              aria-label="Удалить резервацию"
            >
              {'\u2715'}
            </button>
          )}
        </div>
      </div>
    );
  }

  const statusClass = member.status === 'confirmed' ? 'member-item--confirmed' : 'member-item--pending';

  return (
    <div className={`member-item ${statusClass}`}>
      {avatar}
      {roleBadge}
      <div className="mi-content">
        <span className="member-name">
          {renderName(member.telegramId)}
        </span>
        {isCurrentUser && (
          <div className="member-actions">
            {isPending && onConfirm && (
              <button
                type="button"
                className="member-action-btn member-action-btn--confirm"
                onClick={onConfirm}
                aria-label="Подтвердить участие"
              >
                <span className="member-action-icon" aria-hidden="true">{'\u2713'}</span>
                <span className="member-action-text">Подтвердить</span>
              </button>
            )}
            {onLeave && (
              <button
                type="button"
                className="member-remove-btn"
                onClick={onLeave}
                aria-label="Выйти"
              >
                X
              </button>
            )}
          </div>
        )}
        {canEdit && !isCurrentUser && onRemove && (
          <button
            type="button"
            className="member-remove-btn"
            onClick={(e) => {
              e.stopPropagation();
              onRemove(Number(member.telegramId));
            }}
            aria-label="Удалить участника"
          >
            {'\u2715'}
          </button>
        )}
      </div>
    </div>
  );
});
